const STORE_ID = "DASHBOARD";

const TYPES = {
    SET_TAB: "SET_TAB",
    SET_PERMITIONS: 'SET_PERMITIONS',
    SET_PERMITIONS_TABLES: 'SET_PERMITIONS_TABLES',
}

export { STORE_ID, TYPES }